import { createFileRoute } from '@tanstack/react-router'

import { AccountFormPage } from '@/features/account/components/account-form-page'

export const Route = createFileRoute('/_app/settings/user/create')({
  component: Component,
  loader() {
    return {
      crumb: 'Tambah Pengguna',
    }
  },
})

function Component() {
  const navigate = Route.useNavigate()

  return (
    <AccountFormPage
      mode='create'
      onBack={() => navigate({ to: '/settings/user', replace: true })}
    />
  )
}
